// extracted by mini-css-extract-plugin
export default {"image-replacement-anchor":"ImageReplacementAnchor_image-replacement-anchor__eqVAj","image-replacement-anchor__text":"ImageReplacementAnchor_image-replacement-anchor__text__7N-0h"};